import React from 'react';

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-2',
};

/**
 * @param {'sm'|'md'|'lg'} [size]
 * @param {string} [color]  Tailwind border color class, e.g. 'border-blue-500'
 */
export default function Spinner({ size = 'md', color = 'border-blue-500', className = '' }) {
  return (
    <div
      className={[
        'animate-spin rounded-full border-t-transparent',
        sizes[size] ?? sizes.md,
        color,
        className,
      ].join(' ')}
    />
  );
}
